import { useTranslation } from 'react-i18next'

import type { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'

import type { AuthStatus } from '@graphit/types'

import logo from '~/assets/Logo.png'

interface RouterContext {
	queryClient: QueryClient
	auth: AuthStatus
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootComponent,
	notFoundComponent: NotFoundComponent
})

function RootComponent() {
	return (
		<NuqsAdapter>
			<Outlet />
			{process.env.NODE_ENV === 'development' && (
				<>
					<TanStackRouterDevtools position="bottom-right" />
					<ReactQueryDevtools buttonPosition="bottom-left" />
				</>
			)}
		</NuqsAdapter>
	)
}

function NotFoundComponent() {
	const { t } = useTranslation('app')

	return (
		<div className="w-screen h-screen flex flex-col items-center justify-center bg-background gap-6 px-4">
			<img className="max-w-[200px] w-auto" src={logo as string} alt="Graph-it" />
			<p className="text-white text-lg">{t('notFound.message')}</p>
			<Link
				to="/"
				className="px-4 py-2 bg-primary text-white rounded-md font-bold hover:bg-primary-hover transition"
			>
				{t('notFound.goHome')}
			</Link>
		</div>
	)
}
